export const generateLanguageQuery = (fieldName: string) => `{
  ${optionalQuery(`${fieldName}[_key == 'en'][0].value`, true, 'en-us')},
  ${optionalQuery(`${fieldName}[_key == 'es'][0].value`, true, 'es-mx')}
}`

export const optionalQuery = (
  fieldName: string,
  isString: boolean,
  customName?: string
) =>
  `defined(${fieldName})${isString ? `&& length(${fieldName}) > 0` : ''} => {"${customName ?? fieldName}": ${fieldName}}`

export const optionalI18nString = (fieldName: string, customName?: string) =>
  `defined(${fieldName}) && count(${fieldName}) > 0 => {'${customName ?? fieldName}': ${generateLanguageQuery(fieldName)}}`

export const optionalImage = (fieldName: string) => `defined(${fieldName})=>{
  '${fieldName}': ${fieldName}->{
    'url': imageFile.asset->url,
    'altText': ${generateLanguageQuery('altText')}
  }
}`

export const resourcesArray = `resources[]->{
  _id,
  'name': ${generateLanguageQuery('name')},
  source,
  'description': ${generateLanguageQuery('description')},
  format,
  ${optionalQuery('link', true)},
  ${optionalImage('previewImage')}
}`

// No need to filter for only English tips, b/c
//   Remedies and Effects only reference English tips,
//   so those will be the only ones returned.
export const tipsArray = `tips[]->{
  _id,
  name,
  "description": {
    "blocks": description
  },
  ${optionalImage('icon')},
  "es": *[_type == "translation.metadata" && references(^._id)].translations[_key == "es"].value->{
    name,
    "description": {
      "blocks": description
    },
  }
}`
